import React from 'react'
import { Helmet } from 'react-helmet-async'
import { GridItem } from '@which/seatbelt'

import type { SubVerticalCampaignPetitionQuery } from '../../../../generated/frontend'
import { BasicHeader } from '../../../../shared/components/BasicHeader'
import { Breadcrumb } from '../../../../shared/components/Breadcrumb'
import { CampaignPetitionSections } from './components/CampaignPetitionSections'

export const getSubVerticalCampaignPetitionComponents = (
  data: SubVerticalCampaignPetitionQuery['subVerticalPage']
) => {
  let { contentItems } = data.campaignsPetitionCollection
  contentItems = contentItems.filter((n) => n)

  const { petitionDetails } = data.campaignsPetitionCollection
  const { meta, activeCampaign } = petitionDetails

  const mappedContentItems = contentItems.map((contentItem) => {
    return {
      ...contentItem,
      data: {
        ...contentItem.data,
        components: contentItem.data.components.map((item) => {
          return item.type === 'petition-form'
            ? {
                ...item,
                data: {
                  ...item.data,
                  customData: {
                    ...item.data.customData,
                    data: { ...item.data.customData.data, ...petitionDetails },
                  },
                },
              }
            : item
        }),
      },
    }
  })

  const url = typeof window !== 'undefined' ? window.location?.href || '' : ''
  return {
    Breadcrumb: () => (
      <GridItem>
        <Breadcrumb {...data.breadcrumb} />
      </GridItem>
    ),
    CampaignsPetitionCollection: () => (
      <>
        {!activeCampaign && (
          <Helmet>
            <meta name="robots" content="noindex,nofollow,noarchive" />
          </Helmet>
        )}
        {meta.title && (
          <Helmet>
            <script async src="https://platform.twitter.com/widgets.js" />
            <title>{meta.title}</title>
            <meta name="title" content={meta.title} />
            <meta property="og:title" content={meta.title} />
            <meta property="twitter:title" content={meta.title} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="twitter:url" content={url} />
          </Helmet>
        )}
        {meta.description && (
          <Helmet>
            <meta name="description" content={meta.description} />
            <meta property="og:description" content={meta.description} />
            <meta property="twitter:description" content={meta.description} />
          </Helmet>
        )}

        {meta.image && (
          <Helmet>
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="og:image" content={meta.image} />
            <meta property="twitter:image" content={meta.image} />
          </Helmet>
        )}
        <BasicHeader
          header={data.campaignsPetitionCollection.header.title}
          standfirst={data.campaignsPetitionCollection.header.intro}
        />
        <CampaignPetitionSections
          contentItems={mappedContentItems}
          sharingData={data.sharingData}
        />
      </>
    ),
  }
}
